import React, { useEffect, useState } from "react";
import { Row, Col, Container, Table, Button, Modal } from "reactstrap";
import {
  EnableById,
  DisableById,
  DeleteById,
} from "services/api/profile";
// import { ProfileList } from "services/api/role";
import { ProfileList } from "services/api/profile";
import { FormGroup, Input, Label } from "reactstrap";
import toast from "react-hot-toast";
import SignupModel from "../../../components/Modal";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useLocation } from "react-router-dom";

function ProfileTable() {
  const [searchName, setSearchName] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [userListData, setUserListData] = useState();
  const [show, setShow] = useState(false);
  const [refresh, setRefresh] = useState(false);
  // const [skipNo, setSkipNo] = useState(0)

  // pagination
  const [count, setCount] = useState(5);
  const [pageNumber, setPageNumber] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    async function fetchData() {
      let res = await ProfileList({
        name: searchName,
        status: statusFilter,
      });
      setUserListData(res?.data?.data);
    }
    fetchData();
  }, [refresh, searchName, statusFilter]);

  useEffect(() => {
    async function fetchData() {
      let res = await ProfileList();
      setUserListData(res?.data?.data);
    }
    fetchData();
  }, [refresh]);

  const location = useLocation();

  const [section, setSection] = useState(location.pathname.split("/")[1]);

  const handleAddUser = () => {
    setShow(true);
  };
  const handleEnableUser = async (id) => {
    console.log(id, "id");
    let res = await EnableById(id);
    setRefresh(!refresh);
    console.log(res, "res<<<<<<<<<");
  };
  const handleDisableUser = async (id) => {
    console.log(id, "id");
    let res = await DisableById(id);
    setRefresh(!refresh);
    console.log(res, "res<<<<<<<<<");
  };
  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };
  const handleDeleteUser = async (id) => {
    console.log(id, "id");
    let res = await DeleteById(id);
    setRefresh(!refresh);
    console.log(res, "res<<<<<<<<<");
  };
  // const handleUnblockUser = async (id) => {
  //     let res = await UnblockUser(id)
  //     setRefresh(!refresh)
  // }
  const hanldeIncrement = async (el, i) => {
    setPageNumber(pageNumber + 1);
    setRefresh(!refresh);
  };
  const handleDecrement = async (el, i) => {
    setPageNumber(pageNumber - 1);
    setRefresh(!refresh);
  };
  const rowStyles = {
    padding: "20px 0",
  };

  return (
    <>
      {show ? (
        <SignupModel
          section={section}
          refresh={refresh}
          setRefresh={setRefresh}
          userListData={userListData}
          setUserListData={setUserListData}
          setShow={setShow}
          show={show}
        />
      ) : null}

      <div className="mt-5 mt-md-0">
        <Container className="mb-5">
          <h4>Profile Section</h4>
        </Container>
        <Container className="mb-3 sideByside">
          <select
            value={count}
            onChange={(e) => {
              setCount(e.target.value);
              setPageNumber(1);
              setRefresh(!refresh);
            }}
            style={{ width: "100px" }}
          >
            {/* <option hidden selected>Select page no.</option> */}
            <option value="5" selected>
              5
            </option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="25">25</option>
          </select>

          {/* Search Bar */}
          <FormGroup>
            <Label for="searchName">Search by Name</Label>
            <Input
              id="searchName"
              type="text"
              placeholder="Enter Profile name"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />
          </FormGroup>

          {/* Filter Dropdown */}

          <FormGroup>
            <Label for="statusFilter">Filter by Status</Label>
            <Input
              id="statusFilter"
              type="select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="1">Enabled</option>
              <option value="0">Disabled</option>
              <option value="2">Other</option>
            </Input>
          </FormGroup>

          <Button color="primary" onClick={handleAddUser}>
            Add
          </Button>
        </Container>
        <Container className="shape-container d-flex align-items-center ">
          {userListData?.length ? (
            <Table bordered size="sm" className="user-table">
              <thead>
                <tr className="user-table">
                  <th>S.no</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th className="text-center">Actions </th>
                </tr>
              </thead>
              <tbody>
                <tr></tr>
                {userListData?.map((val, i) => {
                  return (
                    <>
                      <tr key={i} className="user-table-col">
                        <td style={rowStyles}>{i + 1}</td>
                        <td style={rowStyles}>{val.name}</td>
                        <td style={rowStyles}>{val.status}</td>
                        <td style={rowStyles}>
                          <div>
                            {val.status == 0 ? (
                              <div>
                                <Button
                                  color="success"
                                  onClick={() => handleEnableUser(val._id)}
                                >
                                  Enable
                                </Button>
                                <Button
                                  color="danger"
                                  onClick={() => confirmDelete(val._id)}
                                >
                                  Delete
                                </Button>
                              </div>
                            ) : val.status == 1 ? (
                              <div>
                                <Button
                                  color="dark"
                                  onClick={() => handleDisableUser(val._id)}
                                >
                                  Disable
                                </Button>
                                <Button
                                  color="danger"
                                  onClick={() => confirmDelete(val._id)}
                                >
                                  Delete
                                </Button>
                              </div>
                            ) : (
                              <div>
                                <Button
                                  disabled
                                  color="success"
                                  onClick={() => handleEnableUser(val._id)}
                                >
                                  Enable
                                </Button>
                                <Button
                                  color="dark"
                                  onClick={() => handleDisableUser(val._id)}
                                >
                                  Disable
                                </Button>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <div className="text-center w-100">
              <p>No Results Found</p>
            </div>
          )}
        </Container>
        <div className="mt-3">
          <Container>
            <Button
              color="primary"
              disabled={pageNumber == 1 ? true : false}
              onClick={() => handleDecrement()}
            >
              <FaChevronLeft />
            </Button>
            <span className="whiteBold mr-2">{pageNumber}</span>
            <Button
              color="primary"
              disabled={userListData?.length < count ? true : false}
              onClick={() => hanldeIncrement()}
            >
              <FaChevronRight />
            </Button>
          </Container>
        </div>
      </div>

      <Modal isOpen={showDeleteModal} toggle={() => setShowDeleteModal(false)}>
        <div className="modal-header">
          <h5 className="modal-title">Confirm Delete</h5>
          <button
            aria-label="Close"
            className="close"
            type="button"
            onClick={() => setShowDeleteModal(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          Are you sure you want to delete this department?
        </div>
        <div className="modal-footer">
          <Button
            color="danger"
            onClick={async () => {
              await DeleteById(deleteId);
              toast.success("Department deleted!");
              setRefresh(!refresh);
              setShowDeleteModal(false);
            }}
          >
            Yes, Delete
          </Button>
          <Button color="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default ProfileTable;
